module.exports = __webpack_public_path__ + "static/platform-8a91d0fbf21de1647ed474686cd95827.png";